// Section headers for a flat FlatList (keeps stickyHeaderIndices and the
// header rows the screens already render above the list).

/**
 * Inserts a header row before each run of items sharing a group key, in list
 * order. Items without a key get no header.
 * @param items
 * @param keyOf   item → group key (date, locality, …) or null
 * @param type    header row `_type`, e.g. "DATE_HEADER"
 * @param field   header row field that carries the key, e.g. "date"
 * @returns rows: `{ _key: "<prefix>_<key>", _type, [field]: key }` + items
 */
export function withGroupHeaders(items = [], { keyOf, type, field, prefix }) {
  const rows = [];
  let current = null;
  (items || []).forEach((item) => {
    const key = keyOf(item);
    if (key && key !== current) {
      current = key;
      rows.push({ _key: `${prefix}_${key}`, _type: type, [field]: key });
    }
    rows.push(item);
  });
  return rows;
}
